<div class="grid dashboard" *ngIf="statistics">
  <div class="col" *ngIf="statistics.assignedToMe">
    <incidents-statistics-item
      description="Assigned to me"
      [amount]="statistics.assignedToMe.amount"
      [colour]="statistics.assignedToMe.colour"
    ></incidents-statistics-item>
  </div>
  <div class="col" *ngIf="statistics.unassigned">
    <incidents-statistics-item
      description="Unassigned"
      [amount]="statistics.unassigned.amount"
      [colour]="statistics.unassigned.colour"
    ></incidents-statistics-item>
  </div>
  <div class="col" *ngIf="statistics.opened">
    <incidents-statistics-item
      description="Opened"
      [amount]="statistics.opened.amount"
      [colour]="statistics.opened.colour"
    ></incidents-statistics-item>
  </div>
  <div class="col" *ngIf="statistics.lessThan1HourOld">
    <incidents-statistics-item
      description="< 1 hours old"
      [amount]="statistics.lessThan1HourOld.amount"
      [colour]="statistics.lessThan1HourOld.colour"
    ></incidents-statistics-item>
  </div>
  <div class="col" *ngIf="statistics.lessThan3HoursOld">
    <incidents-statistics-item
      description="< 3 hours old"
      [amount]="statistics.lessThan3HoursOld.amount"
      [colour]="statistics.lessThan3HoursOld.colour"
    ></incidents-statistics-item>
  </div>
  <div class="col" *ngIf="statistics.greaterThan3HoursOld">
    <incidents-statistics-item
      description="> 3 hours old"
      [amount]="statistics.greaterThan3HoursOld.amount"
      [colour]="statistics.greaterThan3HoursOld.colour"
    ></incidents-statistics-item>
  </div>
  <div class="col" *ngIf="statistics.closed">
    <incidents-statistics-item
      description="Closed"
      [amount]="statistics.closed.amount"
      [colour]="statistics.closed.colour"
    ></incidents-statistics-item>
  </div>
</div>
